<div *ngIf="showIncrease">
    <!-- <img class="pt-5" src="assets/images/auction-end-reserve.svg">
    <h2 class="title">{{"Auction Item.The auction has ended"|translate}}</h2> -->
    <h2 class="title-sec">{{"items-requests.You're the top bidder" | translate}}</h2>
    <h2 class="txt-reserve">{{"items-requests.To win this item, you must raise your bid by" | translate}} <b>{{"Auction Item.SR"|translate}} {{raisePrice | number}}</b> 
      {{"items-requests.more to meet the reserve price" | translate}}</h2>

    <div class="reserve-price">
      <!-- <div class="timer">
        <p>Hurry! Make your decision before:</p>
        <app-auction-end-count-down [TotalTime]="120" [RemainingTime]="auctionData?.remaining_minutes_for_reserve"
          TimerMode="minute"></app-auction-end-count-down>

      </div> -->
      <div class="increase-price">
        <div class="reserve">
          <p class="txt">{{'Auction Item.Reserveprice' | translate}}</p>
          <p class="price">{{"Auction Item.SR"|translate}} <b>{{ auctionData.reserve_price | number }}</b></p>
        </div>
        <div class="you-balance">
          <div class="increase-last-bid">
            <p class="txt">{{'Auction Item.Your last bid' | translate}}</p>
            <p class="price">{{"Auction Item.SR"|translate}} <b>{{ number |number}}</b></p>
          </div>
          <div class="current-balance">
            <p class="txt">{{'items-requests.Current Balance' | translate}}</p>
            <p class="price">{{"Auction Item.SR"|translate}} <b>{{myBlanace | number}}</b></p>
          </div>
        </div>
        <div class="action-increase">
          <button (click)="increasePrice()" mat-button class="btn_fill mb-4" type="submit" [appLoading]="loading">
            {{'items-requests.Increase bid by' | translate}} {{"Auction Item.SR"|translate}} {{raisePrice | number}}</button>

        </div>
      </div>
    </div>
</div>